class Service {
  constructor() {
    this.id = null;
    this.name = "";
    this.url = "";
    this.slug = "";
    this.category = null;
    this.country = null;
    this.presential_venues = [];
    this.online_venues = [];
    this.tags_text = "";
    this.tags = [];
    this.last_modified = null;
    this.status = "";
  }

  set(service) {
    this.id = service.id;
    this.name = service.name;
    this.url = service.url;
    this.slug = service.slug;
    this.country = service.country;
    this.category = service.category
      ? {
          id: service.category.id,
          name: service.category.name,
          slug: service.category.slug
        }
      : null;
    this.presential_venues = service.presential_venues;
    this.online_venues = service.online_venues;
    this.tags_text = service.tags.join(", ");
    this.tags = service.tags;
    this.last_modified = service.last_modified;
    this.status = service.status;
  }

  form() {
    let form = {
      title: this.id ? "Editar servicio" : "Agregar nuevo servicio",
      fields: [
        {
          id: "name",
          name: "nombre",
          label: "Nombre del servicio",
          rules: "required|max:100",
          type: "text"
        },
        {
          id: "category",
          name: "categoria",
          label: "Categoria",
          rules: "required",
          type: "select",
          data: "categories",
          textOption: ["name"]
        },
        {
          id: "country",
          name: "país",
          label: "País",
          rules: "required",
          type: "select",
          data: "countries",
          textOption: ["name"]
        },
        {
          id: "url",
          name: "url",
          label: "Url",
          rules: "url",
          type: "text"
        },
        {
          id: "tags_text",
          name: "sinonimos",
          label: "Sinónimos de búsqueda (Separados por coma)",
          rules: "",
          type: "text"
        }
      ],
      actions: [
        {
          label: "Cancelar",
          color: "grey",
          callback: "cancel"
        },
        {
          label: this.id ? "Actualizar servicio" : "Crear servicio",
          color: "primary",
          callback: "request",
          url: this.id ? "api/services/update" : "api/services/store",
          method: this.id ? "put" : "post",
          validate: true,
          emit: "updated"
        }
      ]
    };
    return form;
  }
}

export default Service;
